import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";

import Footer from "../../components/Footer";
import DFNavbar from "../../components/Navbar";
import dfwalker_icon from "./../../img/dfwalker/icon.png";
import dfwalker_screen from "./../../img/dfwalker/screen.png";
import dfwalker_display_ortho from "./../../img/dfwalker/displayortho.png";
import dfwalker_create_polygon from "./../../img/dfwalker/createpolygon.png";
import dfwalker_display_polygon from "./../../img/dfwalker/displaypolygon.png";
import { ScrollToTop } from "../../components/ScrollToTop";
import { Helmet } from "react-helmet";
import { DF_WALKER_APP_STORE_LINK, DF_WALKER_GOOGLE_PLAY_LINK } from "../../consts/Installers";
import i18n from "../../i18n/configs";

/**
 * DF Walker詳細画面
 * @returns JSX.Element
 */
const DetailDfwalker = () => {
    const { t } = useTranslation();

    return (
        <div className="flex min-h-screen flex-col">
            <Helmet>
                <title>{t("DetailDfwalker.meta.title")}</title>
                <meta name="description" content={t("DetailDfwalker.meta.description")} />
            </Helmet>
            <ScrollToTop />
            <DFNavbar bottomPadding={true} />
            <div className="flex-grow items-center justify-center px-6 py-8 pt-20 lg:px-20">
                <div className="mx-auto max-w-screen-md px-4 md:px-8">
                    <div className="flex items-center justify-center">
                        <img className="h-20 w-20 p-3" src={dfwalker_icon} alt="dfwalker" />
                        <h1 className="text-center text-2xl font-bold text-gray-800 sm:text-3xl ">DF Walker</h1>
                    </div>

                    <div className="mx-auto mt-10 flex max-w-3xl items-center justify-center">
                        {i18n.language === "ja"
                            ? "「DF Walker」詳細ページは移行しました。"
                            : "The 'DF Walker' details page has been moved."}
                    </div>
                    <div className="mx-auto flex max-w-3xl items-center justify-center">
                        <a
                            href={
                                i18n.language === "ja"
                                    ? "https://deepforest-tech.co.jp/df-walker/"
                                    : "https://deepforest-tech.co.jp/en/df-walker/"
                            }
                            className="link-text mt-4 text-sm font-bold"
                        >
                            {i18n.language === "ja" ? "新しいページへ移動する" : "Go to the new page."}
                        </a>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default DetailDfwalker;
